//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.2.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class DelegationsKpiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    delegationsAboutToExpireKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/DelegationsKpi/DelegationsAboutToExpireKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelegationsAboutToExpireKpi(_response);
        });
    }

    protected processDelegationsAboutToExpireKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }

    activitiesSignedViolatingDelegationRequirementKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/DelegationsKpi/ActivitiesSignedViolatingDelegationRequirementKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivitiesSignedViolatingDelegationRequirementKpi(_response);
        });
    }

    protected processActivitiesSignedViolatingDelegationRequirementKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }
}

export class DrugListKpiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    numDrugListActivitiesWhereGivenDeviatesFromExpectedKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/DrugListKpi/DrugListActivitiesWhereGivenDeviatesFromExpectedKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNumDrugListActivitiesWhereGivenDeviatesFromExpectedKpi(_response);
        });
    }

    protected processNumDrugListActivitiesWhereGivenDeviatesFromExpectedKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }
}

export class GeneralKpiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSigningStatusesKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/GeneralKpi/GetSigningStatusesKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSigningStatusesKpi(_response);
        });
    }

    protected processGetSigningStatusesKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }

    getNumDelayedActivitiesKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/GeneralKpi/GetNumDelayedActivitiesKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNumDelayedActivitiesKpi(_response);
        });
    }

    protected processGetNumDelayedActivitiesKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }

    getNumUnsignedActivitiesKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/GeneralKpi/GetNumUnsignedActivitiesKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNumUnsignedActivitiesKpi(_response);
        });
    }

    protected processGetNumUnsignedActivitiesKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }

    getPlannedActivityTimeKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/GeneralKpi/GetPlannedActivityTimeKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlannedActivityTimeKpi(_response);
        });
    }

    protected processGetPlannedActivityTimeKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }

    getFutureUnplannedActivitiesKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/GeneralKpi/GetFutureUnplannedActivitiesKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFutureUnplannedActivitiesKpi(_response);
        });
    }

    protected processGetFutureUnplannedActivitiesKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }

    getActivitiesAboutToEndKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/GeneralKpi/GetActivitiesAboutToEndKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivitiesAboutToEndKpi(_response);
        });
    }

    protected processGetActivitiesAboutToEndKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }
}

export class NotificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listNewNotificationsForUser(organizationId: number, areaIds: number[]): Promise<NotificationListItem[]> {
        let url_ = this.baseUrl + "/dashboard/api/notification/list/organization/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNewNotificationsForUser(_response);
        });
    }

    protected processListNewNotificationsForUser(response: Response): Promise<NotificationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationListItem[]>(null as any);
    }

    listNotificationsPaged(page: number | undefined, pageSize: number | undefined, organizationId: number | null | undefined, areaId: number | null | undefined, areaIds: number[]): Promise<PageResultOfNotificationListItem> {
        let url_ = this.baseUrl + "/dashboard/api/notification/listpage?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (areaId !== undefined && areaId !== null)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListNotificationsPaged(_response);
        });
    }

    protected processListNotificationsPaged(response: Response): Promise<PageResultOfNotificationListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageResultOfNotificationListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageResultOfNotificationListItem>(null as any);
    }

    saveLatestNotificationReadOnUser(notificationId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/dashboard/api/notification/savelatestnotificationreaduser/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveLatestNotificationReadOnUser(_response);
        });
    }

    protected processSaveLatestNotificationReadOnUser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class VersionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAppVersion(): Promise<string> {
        let url_ = this.baseUrl + "/dashboard/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppVersion(_response);
        });
    }

    protected processGetAppVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class WorkScheduleKpiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getEfficiencyRateKpi(organizationId: number, areaIds: number[]): Promise<KeyPerformanceIndicatorItem> {
        let url_ = this.baseUrl + "/dashboard/api/WorkScheduleKpi/GetEfficiencyRateKpi/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEfficiencyRateKpi(_response);
        });
    }

    protected processGetEfficiencyRateKpi(response: Response): Promise<KeyPerformanceIndicatorItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KeyPerformanceIndicatorItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyPerformanceIndicatorItem>(null as any);
    }
}

export class KeyPerformanceIndicatorItem implements IKeyPerformanceIndicatorItem {
    id!: number;
    value?: number | undefined;
    valueUnit!: KeyPerformanceIndicatorUnit;
    valueTitle?: string | undefined;
    valueDescription?: string | undefined;
    separator!: string;
    details?: KeyPerformanceIndicatorDetailItem[] | undefined;
    createdOn!: Date;
    actionLink?: string | undefined;
    category!: KeyPerformanceIndicatorCategory;
    type!: KeyPerformanceIndicatorType;

    constructor(data?: IKeyPerformanceIndicatorItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.valueUnit = _data["valueUnit"];
            this.valueTitle = _data["valueTitle"];
            this.valueDescription = _data["valueDescription"];
            this.separator = _data["separator"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(KeyPerformanceIndicatorDetailItem.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.actionLink = _data["actionLink"];
            this.category = _data["category"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): KeyPerformanceIndicatorItem {
        data = typeof data === 'object' ? data : {};
        let result = new KeyPerformanceIndicatorItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["valueUnit"] = this.valueUnit;
        data["valueTitle"] = this.valueTitle;
        data["valueDescription"] = this.valueDescription;
        data["separator"] = this.separator;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["actionLink"] = this.actionLink;
        data["category"] = this.category;
        data["type"] = this.type;
        return data;
    }
}

export interface IKeyPerformanceIndicatorItem {
    id: number;
    value?: number | undefined;
    valueUnit: KeyPerformanceIndicatorUnit;
    valueTitle?: string | undefined;
    valueDescription?: string | undefined;
    separator: string;
    details?: KeyPerformanceIndicatorDetailItem[] | undefined;
    createdOn: Date;
    actionLink?: string | undefined;
    category: KeyPerformanceIndicatorCategory;
    type: KeyPerformanceIndicatorType;
}

export enum KeyPerformanceIndicatorUnit {
    Pieces = "Pieces",
    Percentage = "Percentage",
    Minutes = "Minutes",
    Hours = "Hours",
    Days = "Days",
    None = "None",
}

export class KeyPerformanceIndicatorDetailItem implements IKeyPerformanceIndicatorDetailItem {
    id!: number;
    value!: number;
    suppressValueAndUnit!: boolean;
    valueUnit!: KeyPerformanceIndicatorUnit;
    valueTitle?: string | undefined;
    actionLink?: string | undefined;

    constructor(data?: IKeyPerformanceIndicatorDetailItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.suppressValueAndUnit = _data["suppressValueAndUnit"];
            this.valueUnit = _data["valueUnit"];
            this.valueTitle = _data["valueTitle"];
            this.actionLink = _data["actionLink"];
        }
    }

    static fromJS(data: any): KeyPerformanceIndicatorDetailItem {
        data = typeof data === 'object' ? data : {};
        let result = new KeyPerformanceIndicatorDetailItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["suppressValueAndUnit"] = this.suppressValueAndUnit;
        data["valueUnit"] = this.valueUnit;
        data["valueTitle"] = this.valueTitle;
        data["actionLink"] = this.actionLink;
        return data;
    }
}

export interface IKeyPerformanceIndicatorDetailItem {
    id: number;
    value: number;
    suppressValueAndUnit: boolean;
    valueUnit: KeyPerformanceIndicatorUnit;
    valueTitle?: string | undefined;
    actionLink?: string | undefined;
}

export enum KeyPerformanceIndicatorCategory {
    General = "General",
    WorkSchedule = "WorkSchedule",
    Delegation = "Delegation",
    DrugList = "DrugList",
}

export enum KeyPerformanceIndicatorType {
    SingleValue = "SingleValue",
    SingleValueWithDetails = "SingleValueWithDetails",
    PieChart = "PieChart",
    PieChartWithDetails = "PieChartWithDetails",
}

export class NotificationListItem implements INotificationListItem {
    id!: number;
    title!: string;
    description!: string;
    createdOn!: Date;
    actionLink!: string;
    categoryId!: NotificationCategoryEnum;
    category!: NotificationCategory;

    constructor(data?: INotificationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.category = new NotificationCategory();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.actionLink = _data["actionLink"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? NotificationCategory.fromJS(_data["category"]) : new NotificationCategory();
        }
    }

    static fromJS(data: any): NotificationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["actionLink"] = this.actionLink;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }
}

export interface INotificationListItem {
    id: number;
    title: string;
    description: string;
    createdOn: Date;
    actionLink: string;
    categoryId: NotificationCategoryEnum;
    category: NotificationCategory;
}

export enum NotificationCategoryEnum {
    General = "General",
    Activity = "Activity",
    Area = "Area",
    Customer = "Customer",
    CustomerArea = "CustomerArea",
    CustomerPausedPeriod = "CustomerPausedPeriod",
    CustomerStatus = "CustomerStatus",
    Delegation = "Delegation",
    DelegationCategory = "DelegationCategory",
    DelegationInheritance = "DelegationInheritance",
    Kiosk = "Kiosk",
    KioskArea = "KioskArea",
    Legislation = "Legislation",
    Organization = "Organization",
    Route = "Route",
    TemplateActivity = "TemplateActivity",
    TemplateActivityCategory = "TemplateActivityCategory",
    TemplateActivityDelegation = "TemplateActivityDelegation",
    TemplateActivityInheritance = "TemplateActivityInheritance",
    Unit = "Unit",
    User = "User",
    UnitArea = "UnitArea",
    UnitDelegation = "UnitDelegation",
    UnitDelegationPlacement = "UnitDelegationPlacement",
    WorkScheduleCommonShift = "WorkScheduleCommonShift",
}

export class NotificationCategory implements INotificationCategory {
    id!: NotificationCategoryEnum;
    value!: string;

    constructor(data?: INotificationCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NotificationCategory {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface INotificationCategory {
    id: NotificationCategoryEnum;
    value: string;
}

export abstract class PageResult implements IPageResult {
    page!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPageResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PageResult {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PageResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPageResult {
    page: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class PageResultOfNotificationListItem extends PageResult implements IPageResultOfNotificationListItem {
    items!: NotificationListItem[];
    searchOptions!: PageSearchOptions;

    constructor(data?: IPageResultOfNotificationListItem) {
        super(data);
        if (!data) {
            this.items = [];
            this.searchOptions = new PageSearchOptions();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NotificationListItem.fromJS(item));
            }
            this.searchOptions = _data["searchOptions"] ? PageSearchOptions.fromJS(_data["searchOptions"]) : new PageSearchOptions();
        }
    }

    static fromJS(data: any): PageResultOfNotificationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PageResultOfNotificationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["searchOptions"] = this.searchOptions ? this.searchOptions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPageResultOfNotificationListItem extends IPageResult {
    items: NotificationListItem[];
    searchOptions: PageSearchOptions;
}

export class PageSearchOptions implements IPageSearchOptions {
    page!: number;
    pageSize!: number;
    organizationId?: number | undefined;
    areaId?: number | undefined;

    constructor(data?: IPageSearchOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.organizationId = _data["organizationId"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): PageSearchOptions {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["organizationId"] = this.organizationId;
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface IPageSearchOptions {
    page: number;
    pageSize: number;
    organizationId?: number | undefined;
    areaId?: number | undefined;
}

export abstract class ServiceError implements IServiceError {

    constructor(data?: IServiceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ServiceError {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServiceError' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IServiceError {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}